module.exports = __webpack_public_path__ + "img/numeralia_cedis_4.31b92b35.png";